export default function($form) {
    if (!(window.$Env && $Env.noSendBackValid) && !$form.isValid(true)) {
        return;
    }

    var $params = $form.getExtForm();

    if ($form.fireEvent("beforereject", $params, fn) === false) return;
    fn();

    //function doReject(){

    //PF.action.flowsave($form, $params.formData); //不用这个，第一保存后回调函数不是一个方法，第二，有的项目退回不用校验表单必填项
    function fn() {
        $params.startProcess(() => {});
        var p = {
            taskId: $params.taskId,
            appId: $params.appId,
            formId: $params.formId
        }
        if ($params.extParams && $params.extParams.fullAuthType) {
            p.fullAuthType = $params.extParams.fullAuthType;
        }
        p.formObj = $form;
        if ($params.comment) {
            p.comment = $params.comment;
        }
        PF.show('flowReject', p, $params.formActionComplete);
    }
    // }
    //$params.startProcess(doReject);
}


// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-reject.js